module.exports = __webpack_public_path__ + "static/media/FXS.5a34828b.png";